import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  uk: {
    translation: {
      // Navigation
      "about": "Про нас",
      "services": "Послуги",
      "advantages": "Переваги",
      "contact": "Контакти",
      
      // Hero Section
      "hero.title": "HOKS",
      "hero.subtitle": "Розробка сайтів і мобільних застосунків",
      "hero.description": "Створюємо сучасні digital-рішення, які допомагають бізнесу розвиватися та досягати нових висот в інтернеті",
      "hero.cta": "Розпочати проект",
      
      // About Section
      "about.title": "/ ПРО НАС",
      "about.description1": "HOKS — це команда досвідчених розробників, які створюють унікальні digital-рішення для бізнесу будь-якого масштабу.",
      "about.description2": "Ми поєднуємо сучасні технології з креативним підходом, щоб створювати продукти, які справді працюють та приносять результат.",
      "about.stats.projects": "Проектів",
      "about.stats.experience": "Років досвіду", 
      "about.stats.clients": "Задоволених клієнтів",
      "about.stats.support": "Підтримка",
      "about.skills.title": "Технічні навички",
      
      // Services Section
      "services.title": "/ НАШІ ПОСЛУГИ",
      "services.item1": "Розробка сайтів «під ключ»",
      "services.item1.description": "Повний цикл розробки сайтів від концепції до запуску. Адаптивний дизайн, SEO-оптимізація, інтеграція з системами управління контентом.",
      "services.item1.technologies": "React, Vue.js, WordPress, PHP, Node.js",
      "services.item2": "Frontend і Backend розробка",
      "services.item2.description": "Розробка клієнтської та серверної частини додатків. REST API, бази даних, інтеграція зовнішніх сервісів, хмарні рішення.",
      "services.item2.technologies": "React, Angular, Node.js, Python, PostgreSQL, MongoDB",
      "services.item3": "Створення інтернет-магазинів",
      "services.item3.description": "Розробка онлайн-магазинів з системами оплати, управління товарами, аналітикою продажів та інтеграцією з логістичними сервісами.",
      "services.item3.technologies": "WooCommerce, Shopify, Magento, Stripe, PayPal",
      "services.item4": "UI/UX-дизайн",
      "services.item4.description": "Дизайн користувальницьких інтерфейсів та UX дослідження. Прототипування, wireframes, дизайн-системи, usability тестування.",
      "services.item4.technologies": "Figma, Adobe XD, Sketch, InVision, Principle",
      "services.item5": "Розробка мобільних застосунків (iOS та Android)",
      "services.item5.description": "Нативні та кросплатформні мобільні додатки для iOS та Android. Інтеграція з API, push-сповіщення, офлайн режим.",
      "services.item5.technologies": "React Native, Flutter, Swift, Kotlin, Firebase",
      "services.item6": "Технічна підтримка та супровід",
      "services.item6.description": "Постійна технічна підтримка, оновлення безпеки, моніторинг продуктивності, резервне копіювання та оптимізація.",
      "services.item6.technologies": "AWS, Google Cloud, Docker, Kubernetes, Monitoring",
      
      // Advantages Section
      "advantages.title": "/ ЧОМУ HOKS",
      "advantages.item1.title": "Сучасні технології",
      "advantages.item1.desc": "Використовуємо найновіші технології та фреймворки для створення швидких і надійних рішень",
      "advantages.item2.title": "Індивідуальний підхід",
      "advantages.item2.desc": "Кожен проект розробляємо з урахуванням специфіки вашого бізнесу та потреб аудitorії",
      "advantages.item3.title": "Повний цикл розробки",
      "advantages.item3.desc": "Від ідеї до запуску — супроводжуємо проект на всіх етапах розробки",
      "advantages.item4.title": "Постійна підтримка",
      "advantages.item4.desc": "Надаємо технічну підтримку та оновлення після запуску проекту",
      
      // Contact Section
      "contact.title": "/ КОНТАКТИ",
      "contact.subtitle": "Готові почати новий проект?",
      "contact.description": "Напишіть нам, і ми обговоримо деталі вашого проекту",
      "contact.support247": "24/7 Підтримка",
      "contact.support247.desc": "Завжди готові допомогти",
      "contact.fastResponse": "Швидка відповідь", 
      "contact.fastResponse.desc": "Відповідаємо протягом години",
      "contact.email.desc": "Зв'яжіться з нами",
      "contact.form.name": "Ім'я",
      "contact.form.name.placeholder": "Ваше ім'я",
      "contact.form.email": "Email",
      "contact.form.email.placeholder": "your@email.com",
      "contact.form.phone": "Телефон (опціонально)",
      "contact.form.phone.placeholder": "+380 XX XXX XX XX",
      "contact.form.service": "Послуга",
      "contact.form.service.placeholder": "Оберіть послугу",
      "contact.form.service.website": "Розробка сайту",
      "contact.form.service.mobile": "Мобільний застосунок",
      "contact.form.service.ecommerce": "Інтернет-магазин",
      "contact.form.service.design": "UI/UX дизайн",
      "contact.form.service.support": "Технічна підтримка",
      "contact.form.service.other": "Інше",
      "contact.form.message": "Повідомлення",
      "contact.form.message.placeholder": "Розкажіть детальніше про ваш проект...",
      "contact.form.submit": "Надіслати",
      "contact.form.success": "Дякуємо! Ваше повідомлення надіслано успішно.",
      "contact.form.error": "Виникла помилка. Спробуйте ще раз.",
      
      // Footer
      "footer.copyright": "© 2025 HOKS. Всі права захищені.",
      "footer.email": "hello@hoks.digital",
      "footer.tagline": "Створено з професіоналізмом для вашого успіху"
    }
  },
  en: {
    translation: {
      // Navigation
      "about": "About",
      "services": "Services",
      "advantages": "Advantages",
      "contact": "Contact",
      
      // Hero Section
      "hero.title": "HOKS",
      "hero.subtitle": "Website & Mobile App Development",
      "hero.description": "We create modern digital solutions that help businesses grow and reach new heights on the internet",
      "hero.cta": "Start Project",
      
      // About Section
      "about.title": "/ ABOUT US",
      "about.description1": "HOKS is a team of experienced developers who create unique digital solutions for businesses of any scale.",
      "about.description2": "We combine modern technologies with a creative approach to create products that truly work and deliver results.",
      "about.stats.projects": "Projects",
      "about.stats.experience": "Years Experience", 
      "about.stats.clients": "Satisfied Clients",
      "about.stats.support": "Support",
      "about.skills.title": "Technical Skills",
      
      // Services Section
      "services.title": "/ OUR SERVICES",
      "services.item1": "Turnkey website development",
      "services.item1.description": "Full cycle website development from concept to launch. Responsive design, SEO optimization, content management system integration.",
      "services.item1.technologies": "React, Vue.js, WordPress, PHP, Node.js",
      "services.item2": "Frontend & Backend development",
      "services.item2.description": "Client-side and server-side application development. REST API, databases, external service integration, cloud solutions.",
      "services.item2.technologies": "React, Angular, Node.js, Python, PostgreSQL, MongoDB",
      "services.item3": "E-commerce solutions",
      "services.item3.description": "Online store creation with payment systems, product management, sales analytics and logistics service integration.",
      "services.item3.technologies": "WooCommerce, Shopify, Magento, Stripe, PayPal",
      "services.item4": "UI/UX design",
      "services.item4.description": "User interface design and UX research. Prototyping, wireframes, design systems, usability testing.",
      "services.item4.technologies": "Figma, Adobe XD, Sketch, InVision, Principle",
      "services.item5": "Mobile app development (iOS & Android)",
      "services.item5.description": "Native and cross-platform mobile apps for iOS and Android. API integration, push notifications, offline mode.",
      "services.item5.technologies": "React Native, Flutter, Swift, Kotlin, Firebase",
      "services.item6": "Technical support and maintenance",
      "services.item6.description": "Ongoing technical support, security updates, performance monitoring, backup and optimization.",
      "services.item6.technologies": "AWS, Google Cloud, Docker, Kubernetes, Monitoring",
      
      // Advantages Section
      "advantages.title": "/ WHY HOKS",
      "advantages.item1.title": "Modern Technologies",
      "advantages.item1.desc": "We use the latest technologies and frameworks to create fast and reliable solutions",
      "advantages.item2.title": "Individual Approach",
      "advantages.item2.desc": "We develop each project taking into account the specifics of your business and audience needs",
      "advantages.item3.title": "Full Development Cycle",
      "advantages.item3.desc": "From idea to launch — we support the project at all stages of development",
      "advantages.item4.title": "Ongoing Support",
      "advantages.item4.desc": "We provide technical support and updates after project launch",
      
      // Contact Section
      "contact.title": "/ CONTACT",
      "contact.subtitle": "Ready to start a new project?",
      "contact.description": "Write to us and we'll discuss the details of your project",
      "contact.support247": "24/7 Support",
      "contact.support247.desc": "Always ready to help",
      "contact.fastResponse": "Fast Response", 
      "contact.fastResponse.desc": "We respond within an hour",
      "contact.email.desc": "Contact us",
      "contact.form.name": "Name",
      "contact.form.name.placeholder": "Your name",
      "contact.form.email": "Email",
      "contact.form.email.placeholder": "your@email.com",
      "contact.form.phone": "Phone (optional)",
      "contact.form.phone.placeholder": "+1 XXX XXX XXXX",
      "contact.form.service": "Service",
      "contact.form.service.placeholder": "Select service",
      "contact.form.service.website": "Website Development",
      "contact.form.service.mobile": "Mobile App",
      "contact.form.service.ecommerce": "E-commerce",
      "contact.form.service.design": "UI/UX Design",
      "contact.form.service.support": "Technical Support",
      "contact.form.service.other": "Other",
      "contact.form.message": "Message",
      "contact.form.message.placeholder": "Tell us more about your project...",
      "contact.form.submit": "Send",
      "contact.form.success": "Thank you! Your message has been sent successfully.",
      "contact.form.error": "An error occurred. Please try again.",
      
      // Footer
      "footer.copyright": "© 2025 HOKS. All rights reserved.",
      "footer.email": "hello@hoks.digital",
      "footer.tagline": "Created with professionalism for your success"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'uk', // default language
    fallbackLng: 'uk',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;